import { render, staticRenderFns } from "./animation-button.vue?vue&type=template&id=4403c724&scoped=true&"
import script from "./animation-button.vue?vue&type=script&lang=js&"
export * from "./animation-button.vue?vue&type=script&lang=js&"
import style0 from "./animation-button.vue?vue&type=style&index=0&id=4403c724&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4403c724",
  null
  
)

export default component.exports